<template>
  <Transition name="page-loading-slide-up">
    <div
      v-if="state.isOpen"
      data-component="CsPageLoading"
      class="fixed z-[1500] top-0 left-0 w-full h-full bg-white/50 dark:bg-neutral-dark/50"
      :style="{
        backdropFilter: 'blur(6px)',
      }"
    >
      <div class="flex flex-col gap-4 items-center justify-center h-full">
        <img
          class="h-8 w-auto animate-pulse"
          :src="logo"
          alt="Commslayer Logo"
        />
        <p class="text-slate-600 dark:text-white text-sm">{{ state.label }}</p>
      </div>
    </div>
  </Transition>
</template>

<script>
import logoImage from 'dashboard/assets/images/commslayer_logo.svg';
import { pageLoadingState } from './useFullPageLoading';

export default {
  name: 'CsPageLoading',
  computed: {
    logo() {
      return logoImage;
    },
    state() {
      return pageLoadingState;
    },
  },
};
</script>

<style>
/* TODO: Migrate to Tailwind CSS classes (Atomic CSS approach). 
 * Currently using custom CSS since Tailwind's transition-all class is not working as expected.
 */

.page-loading-slide-up-enter-active {
  transition: all 0.3s ease-out;
}

.page-loading-slide-up-enter {
  opacity: 0;
  transform: translateY(8px) scale(0.95);
}

.page-loading-slide-up-enter-to {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.page-loading-slide-up-leave-active {
  transition: all 0.2s ease-in;
}

.page-loading-slide-up-leave {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.page-loading-slide-up-leave-to {
  opacity: 0;
  transform: translateY(8px) scale(1);
}
</style>
